<div class="header">
  <div class="logo">
    <a href="https://theoutlier.co.za" target="_blank"
      ><img src="/outlier-logo.png" alt="Outlier Logo" /></a
    >
  </div>
  <div class="title">
    <div class="title-inner">Two Years of Coronavirus in South Africa</div>
  </div>
  <div class="section-sub-title">March 2020 &mdash; March 2022</div>
  <div class="header-inner" />
</div>

<style>
  .logo {
    width: 100%;
    text-align: center;
    /* border: solid 1px red; */
    margin-bottom: 50px;
  }
  .logo img {
    max-width: 230px;
  }
  .header {
    margin-top: 30px;
    margin-bottom: 30px;
    color: #fff;
    font-family: 'Georgia', 'Titillium Web', Georgia, 'Times New Roman', Times,
      serif;
    /* background: red; */

    /* border-bottom: solid 1px #fff; */
  }
  .header-inner {
    width: 90%;
    max-width: 700px;
    /* border-bottom: solid 1px gray; */
    padding-bottom: 10px;
    margin-left: auto;
    margin-right: auto;
  }

  .title {
    font-weight: bold;

    font-weight: 400;

    font-size: 2.5rem;
    width: 100%;
    width: 100%;
    text-align: center;
    color: #fff;
    font-family: 'PT Serif', Georgia, 'Times New Roman', Times, serif;
    line-height: 2.8rem;
    /* margin-bottom: 30px; */
  }
  .title-inner {
    width: 100%;
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
  }
</style>
